// extracted by mini-css-extract-plugin
export default {"windowStats":"_7H7Ws"};